const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.midwestrailbirds.com'

export interface KazyCupWinner {
  id: string
  year: number
  winner: string
  achievement: string
  description: string
  photo?: string
  createdAt: string
  updatedAt: string
}

export interface CreateKazyCupWinnerData {
  year: number
  winner: string
  achievement: string
  description: string
  photo?: string
}

export interface UpdateKazyCupWinnerData extends Partial<CreateKazyCupWinnerData> {}

export const kazyCupApi = {
  async getWinners(getAccessTokenSilently: () => Promise<string>): Promise<{ winners: KazyCupWinner[] }> {
    const token = await getAccessTokenSilently()
    const response = await fetch(`${API_BASE_URL}/v1/kazy-cup`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`Failed to fetch Kazy Cup winners: ${response.statusText}`)
    }

    return response.json()
  },

  async createWinner(winner: CreateKazyCupWinnerData, getAccessTokenSilently: () => Promise<string>): Promise<{ winner: KazyCupWinner }> {
    const token = await getAccessTokenSilently()
    const response = await fetch(`${API_BASE_URL}/v1/kazy-cup`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(winner),
    })

    if (!response.ok) {
      throw new Error(`Failed to create Kazy Cup winner: ${response.statusText}`)
    }

    return response.json()
  },

  async updateWinner(id: string, updates: UpdateKazyCupWinnerData, getAccessTokenSilently: () => Promise<string>): Promise<{ winner: KazyCupWinner }> {
    const token = await getAccessTokenSilently()
    const response = await fetch(`${API_BASE_URL}/v1/kazy-cup/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updates),
    })

    if (!response.ok) {
      throw new Error(`Failed to update Kazy Cup winner: ${response.statusText}`)
    }

    return response.json()
  },

  async deleteWinner(id: string, getAccessTokenSilently: () => Promise<string>): Promise<void> {
    const token = await getAccessTokenSilently()
    const response = await fetch(`${API_BASE_URL}/v1/kazy-cup/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`Failed to delete Kazy Cup winner: ${response.statusText}`)
    }
  },
}
